/**
 * Performance Booster v4.
 * Handles only work that is still useful after Shopify has rendered the page.
 * Third-party loading policy lives in app embeds or explicit loaders, not in a
 * post-load script-removal pass.
 */
(function () {
  'use strict';

  var root = document.querySelector('.section-performance-booster');
  if (!root) return;

  function enabled(name) {
    return root.getAttribute('data-' + name) !== 'false';
  }

  function deferJudgeMeRendering() {
    if (!enabled('lazy-reviews') || typeof IntersectionObserver === 'undefined') return;

    var widget = document.querySelector('.jdgm-rev-widg, [id*="jdgm-rev"]');
    if (!widget) return;

    var container = widget.closest('.shopify-block, .shopify-app-block') || widget;
    container.style.contentVisibility = 'auto';
    container.style.containIntrinsicSize = 'auto 600px';

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      container.style.contentVisibility = 'visible';
      container.style.containIntrinsicSize = 'auto';
      observer.disconnect();
    }, { rootMargin: '400px' });

    observer.observe(container);
  }

  function optimizeImages() {
    if (!enabled('optimize-images')) return;

    function isCritical(image) {
      return image.loading === 'eager' ||
        image.fetchPriority === 'high' ||
        image.closest('header') !== null ||
        image.closest('.lbf-hero2__slide.is-active') !== null;
    }

    function patch(image) {
      if (!image || isCritical(image)) return;
      if (!image.getAttribute('decoding')) image.decoding = 'async';
      if (!image.getAttribute('loading')) image.loading = 'lazy';
    }

    function patchExisting() {
      var images = document.querySelectorAll('img');
      for (var i = 0; i < images.length; i++) patch(images[i]);
    }

    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(patchExisting, { timeout: 1500 });
    } else {
      window.setTimeout(patchExisting, 500);
    }

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeName === 'IMG') patch(nodes[j]);
          if (!nodes[j].querySelectorAll) continue;
          var images = nodes[j].querySelectorAll('img');
          for (var k = 0; k < images.length; k++) patch(images[k]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 10000);
  }

  function boot() {
    deferJudgeMeRendering();
    optimizeImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
